module.exports = __webpack_public_path__ + "img/corto_dx.4055f43b.png";